(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lance-inquiry"] && !Shopify.designMode) return;
  try {
    class LanceInquiry extends HTMLElement {
  connectedCallback() {
    this.titleEl = this.querySelector('[data-inq-title]');
    this.ctxEl = this.querySelector('[data-inq-ctx]');
    this.ctxField = this.querySelector('[data-inq-ctx-field]');
    this.noteEl = this.querySelector('[data-inq-note]');
    this.querySelector('[data-inq-close]').addEventListener('click', () => { this.hidden = true; });
    this.querySelector('[data-inq-overlay]').addEventListener('click', () => { this.hidden = true; });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.hidden = true; });
    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-lance-inquiry]');
      if (!t) return;
      e.preventDefault();
      this.titleEl.textContent = t.dataset.inqTitle || 'Inquiry';
      const ctx = (t.dataset.inqCtx || '').split('||').filter(Boolean);
      this.ctxEl.innerHTML = ctx.map((c) => `<div style="font-size:14px;font-weight:700;line-height:1.35;">${c}</div>`).join('');
      this.ctxField.value = `${t.dataset.inqTitle || 'Inquiry'} — ${ctx.join(' · ')}`;
      this.noteEl.textContent = t.dataset.inqNote || '';
      this.hidden = false;
    });
  }
}
customElements.define('lance-inquiry', LanceInquiry);
  } catch(e) { console.error(e); }
})();

})();
